/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientActivationsPatientActivation from './PatientActivationsPatientActivation';

/**
 * The PatientActivationsBody model module.
 * @module model/PatientActivationsBody
 * @version v0.3
 */
export default class PatientActivationsBody {
  /**
   * Constructs a new <code>PatientActivationsBody</code>.
   * @alias module:model/PatientActivationsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PatientActivationsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientActivationsBody} obj Optional instance to populate.
   * @return {module:model/PatientActivationsBody} The populated <code>PatientActivationsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientActivationsBody();
      if (data.hasOwnProperty('patient_activation'))
        obj.patientActivation = PatientActivationsPatientActivation.constructFromObject(data['patient_activation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PatientActivationsPatientActivation} patientActivation
 */
PatientActivationsBody.prototype.patientActivation = undefined;
